import {Styles} from "../Styles/Styles";
import {useMemo} from "react";
import {ViewTypes} from "../Provider/useGlobalSettingsContextProvider";
import {useLocation, useNavigate} from "react-router-dom";
import styled from "styled-components";
import {Colors} from "../Styles/Colors";

const HeaderStyles = {
    Title: styled.span`
        position: relative;
        display: inline-flex;
        align-items: center;
        padding: 4px 14px 5px 16px;
        color: ${Colors.schemas.text};
        font-size: clamp(1rem, 4vw, 1.35rem);
        font-weight: 800;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        text-shadow:
            0 1px 0 rgba(0, 0, 0, 0.55),
            0 0 14px ${Colors.raw.accent_soft};
    `,
}

export const Header = () => {

    const navigate = useNavigate()
    const location = useLocation()

    const reducePathNameOneLevelDown = () => {
        const pathName = location.pathname.split('/')
        pathName.pop()
        return pathName.join('/')
    }

    const handles = {
        onClose: () => {
            if(  location.pathname.split('/').length > 1 )
                void navigate( reducePathNameOneLevelDown() )
            else
                void navigate('/')
        }
    }

    const title = useMemo( () => {
        const _title = location.pathname?.split('/')?.[1] ?? ''
        switch( _title ){
            case ViewTypes.EMail:
                return 'E-Mail'
            // case ViewTypes.ListOfEmails:
            //     return 'Posteingang'
            case ViewTypes.QRCode:
                return 'Teilen'
            case ViewTypes.Profile:
                return 'Profil'
            case ViewTypes.Friends:
                return 'Leidensgenossen'
            case ViewTypes.VerseGuide:
                // case ViewTypes.VerseGuideSystem:
                return 'Galaxy-Wissen'
            case ViewTypes.Squad:
                return 'Squad'
            case ViewTypes.Ships:
                return 'Schiffe & Co.'
            case ViewTypes.IndustrialJobs:
                return 'Industrie & Aufträge'
            default:
                return "Dashboard"
        }
    }, [location] )

    return <div id={'DataPad-Header'}>
        <Styles.DataPad.Header.Frame>
            <HeaderStyles.Title>{ title }</HeaderStyles.Title>
            { location.pathname !== '/' &&
                <Styles.DataPad.Header.Button.Close onClick={ handles.onClose }/>
            }
        </Styles.DataPad.Header.Frame>

        <Styles.DataPad.Header.Closing />
    </div>
}